import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
  HttpParams,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, throwError, EMPTY, of } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  catchError,
  map,
  publishReplay,
  refCount,
  share,
} from 'rxjs/operators';
import { AppConfigService } from '../services/config.service';

let headers = new HttpHeaders({
  // 'Content-Type': 'application/json',
  // 'Access-Control-Allow-Origin':  'http://127.0.0.1:4200',
  // 'Access-Control-Allow-Methods': ', GET',
  // 'Access-Control-Allow-Headers': 'Content-Type, Authorization',
  user_token: localStorage.getItem('token'),
});
let options = { headers: headers };

@Injectable({
  providedIn: 'root',
})
export class ReportService {
  private url = this.conf.appConfig.apiBaseUrl;

  public exportData(entity) {
    const url = `${this.conf.appConfig.apiBaseUrl}/AdminPortal/Pdf/Export?entity=${entity}&t=${encodeURIComponent(localStorage.getItem('token') ?? '')}&reportname=${entity}`;
    window.open(url, "_blank");
  }

  public getReportTemplateById(id) {
    const url = `${this.url}/api/reportbuildertemplate/FetchReportBuilderByIdWithParameters?ReportBuilderByIdWithParameters=${id}`;
    const query = {
      pageNumber: '1',
      pageSize: '100',
      // ReportBuilderByIdWithParameters: id,
    };

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  public getReportParamTypes() {
    const url = `${this.url}/api/reportbuildertemplate/FetchReportParamTypes`;
    const query = {
      pageNumber: '1',
      pageSize: '100',
      // ReportBuilderByIdWithParameters: id,
    };

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  public getReportTypes() {
    const url = `${this.url}/api/reportbuildertemplate/FetchReportTypes`;
    const query = {
      pageNumber: '1',
      pageSize: '100',
      // ReportBuilderByIdWithParameters: id,
    };

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  public getReportTemplate() {
    const url = `${this.url}/api/reportbuildertemplate/GetAllReportBuilder`;
    const query = {
      pageNumber: '1',
      pageSize: '100',
      // ReportBuilderByIdWithParameters: id,
    };

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  public getReportLookUpTypes() {
    const url = `${this.url}/api/reportbuildertemplate/FetchLookUpTypes`;
    const query = {
      pageNumber: '1',
      pageSize: '100',
      // ReportBuilderByIdWithParameters: id,
    };

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  public getReportLookUp(lookup_code) {
    const url = `${this.url}/api/reportbuildertemplate/FetchLookUp?lookup_code=${lookup_code}`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  public getCurrency() {
    const url = `${this.url}/api/dropdown/currency`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  public createReportTemplate(
    name: string,
    description: string,
    moduleCode: string,
    reportType: string,
    queryText: string,
    id: number
  ) {
    const data = {
      name,
      description,
      moduleCode,
      reportType,
      queryText,
      id,
    };
    console.log(data);
    const url = `${this.url}/api/reportbuildertemplate/SaveReportBuilder`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }

  public createReportParam(
    reportBuilderTemplateId: number,
    name: string,
    parameterType: string,
    id: number
  ) {
    const data = {
      reportBuilderTemplateId,
      name,
      parameterType,
      id,
    };
    console.log(data);
    const url = `${this.url}/api/reportbuildertemplate/SaveReportParameter`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }

  public generateReport(
    reportTemplateId: number,
    lstParams: [
      {
        paramName: string;
        paramValue: string;
        paramType: string;
      }
    ]
  ) {
    const data = {
      reportTemplateId,
      lstParams,
    };
    console.log(data);
    const url = `${this.url}/api/reportbuildertemplate/ExecuteReport`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }

  changepassword(Current_Password, New_Password) {
    const data = {
      Current_Password,
      New_Password,
    };
    console.log(data);
    const url = `${this.url}/api/accounts/user/changepassword`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }

  constructor(private client: HttpClient, private conf: AppConfigService) {}
}
